import { compose } from 'recompose';

import ProfitLoss from './ProfitLoss';

import apiInterceptor from '../../../api/interceptor';

import { profitLossApi ,balanceSheetApi } from '../../common/base.api';

const composedProfitLoss = compose(apiInterceptor({ ...profitLossApi ,getStartDate: balanceSheetApi.getStartDate }))(ProfitLoss);

export default composedProfitLoss;
